// extracted by mini-css-extract-plugin
module.exports = {"button":"AddToMetamask_button__2PXwS","standalone":"AddToMetamask_standalone__3IJ98","text":"AddToMetamask_text__DiUSH"};